import { NgModule } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterModule,
  RouterStateSnapshot,
  Routes,
} from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { UserListComponent } from "./user-list/user-list.component";
import { NgxPermissionsGuard } from "ngx-permissions";
import { UserFormComponent } from "./user-form/user-form.component";
import { UserResolver } from "./user.resolver";
import { role } from "./role.const";

export function getUserPermissions(
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) {
  // Creating a user posts to an endpoint that requires organization admin.
  if (route.params["id"] === "0") {
    return [role.organizationAdmin];
  }

  return [role.user];
}

const routes: Routes = [
  {
    path: "login",
    pathMatch: "full",
    component: LoginComponent,
  },
  {
    path: "logout",
    pathMatch: "full",
    component: LoginComponent,
  },
  {
    path: "exit",
    pathMatch: "full",
    component: LoginComponent,
  },
  {
    path: "confirmed",
    pathMatch: "full",
    component: LoginComponent,
  },
  {
    path: "register",
    pathMatch: "full",
    canActivate: [NgxPermissionsGuard],
    component: LoginComponent,
    data: {
      permissions: {
        only: getUserPermissions,
        redirectTo: "/",
      },
    },
    resolve: {
      model: UserResolver,
    },
  },
  {
    path: "registered",
    pathMatch: "full",
    component: LoginComponent,
  },
  {
    path: "reset/:token",
    component: LoginComponent,
  },
  {
    path: "join/:token",
    component: LoginComponent,
  },
  {
    path: "activate/:token",
    component: LoginComponent,
  },
  {
    path: "user/list",
    component: UserListComponent,
  },
  {
    path: "user/:id",
    component: UserFormComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: getUserPermissions,
        redirectTo: "/",
      },
    },
    resolve: {
      model: UserResolver,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [UserResolver],
})
export class UserRoutingModule {}
